import { Fragment, useState, useEffect } from "react"
import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Textarea,
} from "@chakra-ui/react"
import { CheckCircleIcon } from "@chakra-ui/icons"

import FormField from "../Common/FormField"
import DeleteButton from "../Common/DeleteButton"

const LocationForm = ({
  title,
  item,
  isLoading,
  onSubmit,
  onRemove,
  modalController,
}) => {
  const [name, setName] = useState(item?.name || "")
  const [zone, setZone] = useState(item?.zone || "")
  const [isRitiro, setIsRitiro] = useState(item?.isRitiro || false)
  const [description, setDescription] = useState(item?.description || "")
  const [pickupDescription, setPickupDescription] = useState(
    item?.pickupDescription || ""
  )

  const onSave = () => {
    onSubmit({
      name,
      zone,
      isRitiro,
      description,
      pickupDescription,
    })
    modalController.onClose()
  }

  useEffect(() => {
    setName(item?.name || "")
    setZone(item?.zone || "")
    setIsRitiro(item?.isRitiro || false)
    setDescription(item?.description || "")
    setPickupDescription(item?.pickupDescription || "")
  }, [item])

  return (
    <Fragment>
      <Modal isOpen={modalController.isOpen} onClose={modalController.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Stack spacing={4}>
              <FormField label="Nome" isRequired>
                <Input
                  placeholder="Nome"
                  size="md"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </FormField>
              <FormField label="Zona" isRequired>
                <Input
                  placeholder="Zona"
                  size="md"
                  value={zone}
                  onChange={(event) => setZone(event.target.value)}
                />
              </FormField>
              <FormField label="Descrizione">
                <Textarea
                  placeholder="Descrizione"
                  size="md"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                />
              </FormField>
              <FormField label="Anche Punto di Ritiro">
                <CheckCircleIcon
                  w={6}
                  h={6}
                  color={isRitiro ? "green.500" : "gray.200"}
                  cursor="pointer"
                  onClick={(e) => {
                    e.stopPropagation()
                    setIsRitiro(!isRitiro)
                  }}
                  position="absolute"
                  top="0"
                  right="0"
                />
              </FormField>
              {isRitiro && (
                <FormField label="Descrizione se Punto di Ritiro">
                  <Textarea
                    placeholder="Descrizione se Punto di Ritiro"
                    size="md"
                    value={pickupDescription}
                    onChange={(event) =>
                      setPickupDescription(event.target.value)
                    }
                  />
                </FormField>
              )}
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Flex justify="space-between" w="full">
              {item && (
                <DeleteButton
                  onClick={() => {
                    onRemove(item.id)
                    modalController.onClose()
                  }}
                  variant="button"
                  mr={3}
                />
              )}
              <Button
                isLoading={isLoading}
                onClick={onSave}
                colorScheme="teal"
                mr={3}
              >
                Salva
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Fragment>
  )
}

export default LocationForm
